<template>
  <div class="offer__information">
    <v-col class="d-flex d-flex-inline window_construction_name mt-n2 mt-sm-3 mb-n2 mb-md-n3 py-2 px-0">
      <noindex>
        {{ window_construction_name }}
      </noindex>
    </v-col>
    <v-row justify="end" style="height: 1px;" class="ma-1 mb-0">
      <v-tooltip aria-label="Как узнать о качестве" position="left">
        <template v-slot:activator="{ props }">
          <span style="padding-top: 1.5px;" role="status" v-bind="props" class="quality_help_text">
            <noindex>
              Качество
            </noindex>
          </span>
        </template>
        <noindex>
          <span>Наведите на иконку и увидите уровень соотношения цена - качество</span>
        </noindex>
      </v-tooltip>
    </v-row>
    <!-- Профиль -->
    <v-col class="d-flex d-flex-inline pa-0 pt-1 py-sm-1 mb-sm-0 inf-line">
      <div class="inf-title"> Профиль: </div>
      <v-col class="inf-value d-flex pa-0" sm="auto" style="margin-top: 2px;" >
				<a v-if="item.profile_url" style="min-width: 50px;"  :href="item.profile_url" target="_blank" rel="noopener" v-html="item.profile_no_index || item.profile"></a>
        <span v-else class="align-center" v-html="item.profile_no_index || item.profile"></span>
      </v-col>
      <div class="dt d-flex align-self-end" style="margin-bottom: -1.5px;"></div>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.profile_quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Фурнитура -->
    <v-col
      class="d-flex d-flex-inline mt-0 pa-0 pb-sm-1 pb-md-0 furniture mb-sm-0 inf-line"
      v-if="item.furniture"
    >
      <div class="inf-title"> Фурнитура: </div>
      <v-col
        class="inf-value d-flex align-center pa-0 sm-wd-fx"
        cols="auto"
        style="padding-top: 1px!important;"
      >
				<a style="min-width: 50px;" v-if="item.furniture.url" :href="item.furniture.url" target="_blank" rel="noopener">{{ item.furniture.text_without_quality }}</a>
        <span v-else class="d-flex align-center">{{ item.furniture.text_without_quality }}</span>
        <v-col
          class="inf-icon d-flex align-center justify-start py-0 px-1"
          md="auto"
          v-if="item.glass_types.includes(antiBurglaryCode) && isMobile"
        >
          <IconWithTooltip icon="antiburglar" code="antiburglar_icon"/>
        </v-col>
      </v-col>
      <v-col
        class="inf-icon d-flex align-center justify-start py-0 px-1 my-auto mx-0"
        md="auto"
        style="height: 20px;"
        v-if="item.glass_types.includes(antiBurglaryCode) && !isMobile"
      >
        <IconWithTooltip icon="antiburglar" code="antiburglar_icon"/>
      </v-col>
      <div class="dt d-flex align-self-end" style="margin-bottom: -2px;"></div>
      <v-col
        cols="auto"
        class="inf-quality pa-0 pl-1 d-flex align-center ml-auto justify-end justify-self-end"
      >
        <QualityIcon
          v-bind:quality="item.furniture.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Стеклопакет -->
    <v-col class="d-flex d-flex-inline glass_packet pa-0 pb-sm-1 pb-md-0 my-sm-n1 inf-line">
      <div class="inf-title" > Стеклопакет:</div>
      <v-col
        class="inf-value d-flex align-center pa-0"
        cols="auto"
        >{{ item.glass_text }}</v-col
      >
      <v-col
        class="inf-icon d-flex align-center justify-start pa-0"
        style="height: 25px"
      >
        <!-- Мультистекло -->
        <IconWithTooltip  v-if="item.glass_types.includes(sunprotectionCode)" icon="antisnowsun" code="glass_multi_icon"/>
        <!-- Триплекс -->
        <IconWithTooltip  v-if="item.glass_types.includes(triplexCode)" icon="antiburglar" code="glass_triplex_icon"/>
        <!-- Двойной триплекс (стекло от шума) -->
        <IconWithTooltip  v-if="item.glass_types.includes(doubleTriplexCode)" icon="antisound" code="double_triplex_icon"/>

        <!-- Низкоэмиссионное стекло (для тепла) -->
        <IconWithTooltip  v-if="item.glass_types.includes(lowEmissionCode)" icon="antisnow" code="glass_ne_icon" />
        <!-- От посторонних взглядов / Зеркальное или тонированное стекло -->
        <IconWithTooltip  v-if="item.glass_types.includes(viewprotectionCode)" icon="antieye" code="glass_view_protection_icon"/>
        <!-- Двойное низкоэмиссионное стекло -->
        <IconWithTooltip  v-if="item.glass_types.includes(doubleLowEmissionCode)" icon="GlassDoubleNE" code="glass_double_ne_icon" style_for_offer_icon="width: 38px;"/>
        <!-- Закаленное стекло -->
        <IconWithTooltip  v-if="item.glass_types.includes(temperedCode)" icon="tempered" code="tempered_window_glass_icon"/>
      </v-col>
    </v-col>

    <!-- Теплосбережение -->
    <v-col class="d-flex d-flex-inline warm_saving pa-0 pb-sm-1 inf-line">
      <div class="inf-title"> <span> <noindex>Тепло:</noindex> </span> </div>
      <!-- TODO Убрать replace когда будет нормальное API для quality -->
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>{{item.text_soundprofing_and_heat_saving.hs_text.replace(' уровень','')}}</noindex>
        </span>
        <div class="dt d-flex align-self-end" style="margin-bottom: -1px !important;"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.text_soundprofing_and_heat_saving.hs_text"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Звукоизоляция -->
    <v-col class="d-flex d-flex-inline pa-0 pb-sm-1 soundproofing inf-line">
      <div class="inf-title"> <noindex> Звукоизоляция: </noindex> </div>
      <!-- TODO Убрать replace когда будет нормальное API для quality -->
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{item.text_soundprofing_and_heat_saving.sp_text.replace(' уровень','')}}
          </noindex>
        </span>
        <div class="dt d-flex align-self-end" style="margin-bottom: -1px!important;"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.text_soundprofing_and_heat_saving.sp_text"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Цвет -->
    <v-col v-if="colors_show && some_color_changed" class="d-flex d-flex-inline pa-0 pt-1 py-sm-1 mb-sm-0 inf-line">
      <div class="inf-title"> Цвет: </div>
      <v-col class="inf-value inf-colors d-flex pa-0 align-center" :class="{'flex-wrap': isMobile}" sm="auto" style="margin-top: 2px;" >
        <v-row class="align-center" no-gutters>
          <v-col cols=11 sm=auto>
          внутри
          </v-col>
          <v-col cols=1 sm=auto>
            <v-tooltip>
              <template #activator="{ props }">
                <div class="d-inline-block mx-sm-1 color-info" v-bind="props">
                  <div :style="`background-color: ${item.window_color_inside.rgb};`"></div>
                </div>
              </template>
              {{ item.window_color_inside.name }}
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col cols=11 sm=auto>
          снаружи
          </v-col>
          <v-col cols=1 sm=auto>
            <v-tooltip>
              <template #activator="{ props }">
                <div class="d-inline-block mx-sm-1 color-info" v-bind="props">
                  <div :style="`background-color: ${item.window_color_outside.rgb};`"></div>
                </div>
              </template>
              {{ item.window_color_outside.name }}
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col cols=11 sm=auto>
          основа профиля
          </v-col>
          <v-col cols=1 sm=auto>
            <v-tooltip>
              <template #activator="{ props }">
                <div class="d-inline-block mx-sm-1 color-info" v-bind="props">
                  <div :style="`background-color: ${item.window_color_solid.rgb};`"></div>
                </div>
              </template>
              {{ item.window_color_solid.name }}
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
    <!-- Цена за окно -->
    <v-col class="d-flex d-flex-inline pa-0 inf-line window-price">
      <div class="inf-title" >Цена за окно(а):</div>
      <v-col
        class="inf-value d-flex align-center text-base-discount pa-0"
        v-if="item.price_type === 'per_window'"
      >
      <div><noindex>Со скидкой </noindex></div>
        <div style="white-space: pre;">{{ ' ' + item.discount + '% - ' + parsePrice().replace(/&nbsp;/g,' ') }}</div>
      </v-col>
      <v-col
        class="inf-value d-flex align-center pa-0"
        v-if="item.price_type == 'per_metre'"
        >
        {{ item.price_per_metre.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
      </v-col>
    </v-col>
    <!-- Дополнительные услуги -->
    <v-row v-if="hasAnyOfADService()" class="inf-line mb-4 mt-2 align-center ma-0" >
      <hr class="v-col mx-2 py-0" />
      <v-col cols="auto" class="py-0 text-center px-1 " >
       <noindex>
         Услуги
       </noindex>
      </v-col>
      <hr class="v-col mx-2 py-0" />
    </v-row>
    <!-- Подоконник -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('sill_inside')"
    >
      <div class="inf-title">Подоконник:</div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{ item.as_details.sill_inside.text }} -
            {{ item.as_details.sill_inside.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
          </noindex>
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.sill_inside.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Отлив -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('sill_outside')"
    >
      <div class="inf-title">Отлив:</div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{ item.as_details.sill_outside.text }} -
            {{ item.as_details.sill_outside.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
          </noindex>
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.sill_outside.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Откос -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('jambs')"
    >
      <div class="inf-title">Откос:</div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{ item.as_details.jambs.text }} -
            {{ item.as_details.jambs.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
          </noindex>
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.jambs.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Сетки -->
    <v-col v-if="hasAnyScreenType()" class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line">
      <div class="inf-title" >Cетка:</div>
      <v-col class="inf-value d-flex align-center pa-0">
        <!-- Москитная сетка -->
        <div
          class="d-flex flex-inline align-center pr-1"
          v-if="hasAdditionalService('mosquitoscreen')"
        >
          <IconWithTooltip icon="antibeetle" text="Москитная сетка"/>
          {{ item.as_details.mosquitoscreen.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
        </div>
        <!-- Антикошка -->
        <div
          v-if="hasAdditionalService('petscreen')"
          class="d-flex flex-inline align-center pr-1"
        >
          <IconWithTooltip icon="cat" text="Антикошка"/>
          {{ item.as_details.petscreen.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
        </div>
        <!-- Антипыль -->
        <div
          v-if="hasAdditionalService('dustscreen')"
          class="d-flex flex-inline align-center pr-1"
        >
          <IconWithTooltip icon="antidust" text="Антипыль"/>
          {{ item.as_details.dustscreen.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
        </div>
      </v-col>
    </v-col>
    <!-- Детский замок -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('as_child_safety')"
    >
      <div class="inf-title" >Детский замок:</div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <IconWithTooltip icon="child" code="child_lock_icon"/>
          {{ item.as_details.as_child_safety.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD; -
          {{ item.as_details.as_child_safety.count }} шт.
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.as_child_safety.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Монтаж Кирпич -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('brick')"
    >
      <div class="inf-title"><noindex>Монтаж:</noindex></div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{item.as_details.brick.text}}
            {{item.as_details.brick.price.toLocaleString('ru').replace(/&nbsp;/g,' ') + '&#x20BD;'}}
          </noindex>
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.brick.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Монтаж Панель -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('panel')"
    >
    <div class="inf-title"><noindex>Монтаж:</noindex></div>
      <v-col class="inf-value d-flex align-center pa-0">
        <span class="d-flex align-center">
          <noindex>
            {{item.as_details.panel.text}}
            {{item.as_details.panel.price.toLocaleString('ru').replace(/&nbsp;/g,' ') + '&#x20BD;'}}
          </noindex>
        </span>
        <div class="dt d-flex align-self-end"></div>
      </v-col>
      <v-col
        cols="auto"
        class="inf-quality pa-0 d-flex align-center justify-end"
      >
        <QualityIcon
          v-bind:quality="item.as_details.panel.quality"
          v-bind:offer_id="item.uniq"
        />
      </v-col>
    </v-col>
    <!-- Демонтаж -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('dismantle')"
    >
      <div class="inf-title"><noindex>Демонтаж:</noindex></div>
      <v-col class="inf-value d-flex align-center pa-0">
        <noindex>
          {{ item.as_details.dismantle.price.toLocaleString("ru").replace(/&nbsp;/g,' ') }} &#x20BD;
        </noindex>
      </v-col>
    </v-col>
    <!-- Доставка -->
    <v-col
      class="d-flex d-flex-inline pa-0 pb-sm-1 inf-line"
      v-if="hasAdditionalService('delivery')"
    >
      <div class="inf-title"><noindex> Доставка: </noindex></div>
      <v-col class="inf-value d-flex align-center pa-0">
        <font-awesome-icon icon="truck" class="mr-1" />
        <span>
          <noindex>
            {{item.as_details.delivery.text}}
            {{item.as_details.delivery.price.toLocaleString('ru').replace(/&nbsp;/g,' ') + '&#x20BD;'}}
          </noindex>
        </span>
      </v-col>
    </v-col>
  </div>
</template>
<script>
import QualityIcon from "../custom_icons/QualityIcon.vue";
import ShowFeeProposals from "./ShowFeeProposals.vue";
import IconWithTooltip from "./IconWithTooltip.vue";

import { isEmptyObj } from "../../func/helpfunk.js";
import { mapState } from 'vuex';
import { railsData } from "../../init_data/rails_data.js";

import { antiBurglaryCode, triplexCode, sunprotectionCode, viewprotectionCode, temperedCode, doubleTriplexCode, lowEmissionCode, doubleLowEmissionCode } from "../../init_data/glass_types_codes.js";

import WindowConstructionM from '../../mixins/WindowConstructionM.js';

export default {
  name: "OfferInformation",
	mixins: [WindowConstructionM],
  props: ["item","colors_show"],
  data() {
    return {
      main_domain: railsData.main_domain,
      antiBurglaryCode,
      triplexCode,
      sunprotectionCode,
      viewprotectionCode,
      temperedCode,
      doubleTriplexCode,
      lowEmissionCode,
      doubleLowEmissionCode,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
    window_construction_name() {
      let lowercased_name = this.item.window_construction_name.toLowerCase()
      let final_name = this.item.window_construction_name;
      if (lowercased_name.includes('балконный блок')) {
        let short_name = lowercased_name.replace('балконный ','');
        final_name = (short_name.charAt(0).toUpperCase() + short_name.slice(1));
      }
      return final_name + ' ' + this.item.block_sizes;
    },
    some_color_changed() {
      return this.item.window_color_inside.rgb !== '#00000000' ||
             this.item.window_color_outside.rgb !== '#00000000' ||
             this.item.window_color_solid.rgb !== '#FFFFFFFF';
    }
  },
  components: {
    QualityIcon,
    ShowFeeProposals,
    IconWithTooltip
  },
  methods: {
    hasAdditionalService(service) {
      return this.item.as_details[service]
    },
    hasAnyOfADService() {
      return !isEmptyObj(this.item.as_details)
    },
    hasAnyScreenType() {
      return (
        this.hasAdditionalService("mosquitoscreen") ||
        this.hasAdditionalService("petscreen") ||
        this.hasAdditionalService("dustscreen")
      );
    },
    parsePrice() {
      let pr = this.item.price_for_window.replace("&#x20BD;", "");
      return parseInt(pr).toLocaleString("ru");
    },
  }
};
</script>
